module.exports = __webpack_public_path__ + "img/subscribe.81f27dfb.svg";